import React, { useState } from "react";
import TopBar from "./TopBar";
import Header from "./Header";
import HeroSection from "./HeroSection";
import FeaturedServices from "./FeaturedServices";
import AboutSection from "./About";
import CountSection from "./CountSection";
import TestimonialsSection from "./TestimonialsSection";
import FaqSection from "./FaqSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

const LandingPage = () => {
  // Estado para controlar si se muestra el mensaje
  const [showMessage, setShowMessage] = useState(false);

  // Función para manejar el clic en el botón
  const handleClick = () => {
    // Cambia el estado para mostrar el mensaje
    setShowMessage(true);
  };

  return (
    <div>
      {/* <TopBar></TopBar> */}
      {/* <Header></Header> */}
      <HeroSection></HeroSection>
      <FeaturedServices></FeaturedServices>
      <AboutSection></AboutSection>
      <CountSection></CountSection>
      {/* <TestimonialsSection></TestimonialsSection> */}
      <FaqSection></FaqSection>
      <ContactSection></ContactSection>
      <Footer></Footer>
    </div>
  );
};

export default LandingPage;
